import {
    CircularProgress as MaterialUICircularProgress,
    CircularProgressProps,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { colors } from "~/theme";

interface WithDarkTheme {
    darkTheme?: boolean;
}
const CircularProgressStyled = withStyles({
    colorPrimary: {
        color: ({ darkTheme }: WithDarkTheme) =>
            darkTheme ? colors.white : colors.black,
    },
})(MaterialUICircularProgress);

export function CircularProgress(props: CircularProgressProps & WithDarkTheme) {
    return <CircularProgressStyled {...props} />;
}
